'use strict';

function parse(reader) {
    reader.readString(6, 'data.params.old_password');
    reader.readString(6, 'data.params.new_password');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/password-setting-parser.js